<template>
    <div class="box-vertical w100" style="height: 100%;position:absolute">
        <div class="wrapper m0 flex-1 w100 box-vertical">
            <div class="body flex-1 box-horizontal m10 ">
                <div class="flex-1 text-center" v-if="get.data.via != 'ovo'">
                    <img src="@/assets/cek.png" class="mb20" style="width: 75px;" />
                    <span class="text-center block w100 f15 primary-color mb20">PEMBAYARAN SELESAI</span>
                    <span class="text-center block w100 f12 black mb20">Periksa Status Pembayaran di</br>HISTORY BAYAR</span>

                    <button class="btn btn-info w100" @click="met.beranda()">Beranda</button>
                </div>
                <div class="flex-1 text-center" v-else>
                    <img src="@/assets/cek.png" class="mb20" style="width: 75px;" />
                    <span class="text-center block w100 f15 primary-color mb20">PEMBAYARAN TELAH DI BUATKAN</span>
                    <span class="text-center block w100 f15 black mb20">Invoice #{{get.data.inv}}</span>
                    <span class="text-center block w100 f12 black mb20">Harap Perika E-wallet OVO anda.</br>Lanjutkan Transaksi Pembayaran dari </br>"MY WIFI / Beatcom RTRW"</span>
                    <span class="text-center block w100 f12 black mb20">Periksa Status Pembayaran di</br>HISTORY BAYAR</span>

                    <button class="btn btn-info w100" @click="met.beranda()">Beranda</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import myGlobal from '@/MyGlobal'
import { reactive } from '@vue/composition-api'

export default {
    setup() {
        const get = {
            data: reactive({
                this: '',
                params: '',
                data: '',
                inv: '',
                via: ''
            }),
            list() {
                var datax = {
                    token: 'TangTung ' //+sessionStorage.getItem('Token')
                };
            
                var apiUrl = inter.KategoriList();

                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));
                    //data.loading = false;
                    if (x.status == true) {
                        mainData.data = x.data;
                        //theGet.data.Total = x.pesan;
                    } else {
                        
                    }
                })
            }
        }

        const met = {
            beranda() {
                if (sessionStorage.getItem("browserToken") == null) {
                    // INI BALIK KE BERANDA VIA APP
                    location.href="https://blonjo.web.id/beat/API/WIFI/webview/3.9.0/#/beranda";
                } else {
                    // INI BALIK KE BERANDA VIA WEB
                    location.href="#/beranda";
                }

            }
        }

        const redirectx = {
            checkApp() {
                myGlobal.checkApp();
            },
            now() {
                location.href="#/";
            }
        }

        return {
            met,
            get,
            redirectx
        }

    },
    mounted () {        
        this.redirectx.checkApp();

        console.log(JSON.stringify(this.$route.params));
        
        this.get.data.params = this.$route.params;
        this.get.data.via = this.$route.params.via;
        //this.get.data.data = JSON.parse(this.$route.params.data);
        this.get.data.inv = this.$route.params.invoice;

        console.log(this.$route.params.invoice+" coba"); 
    }
}
</script>


// WEBPACK FOOTER //
// src/components/User/success/main-ewallet.vue